// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 745 ? "posthog" : chunkId) + "." + {"198":"373cb5e1","266":"38edc46e","584":"e1e9b57e","595":"674dc5b8","602":"791cff61","693":"76a8e525","745":"ab7d0a47"}[chunkId] + ".chunk.js";
};